<template>
    <div class="wrapper">
        <p class="menu_title">{{ $t('my.personalCenter') }}</p>
        <ul class="menuList">
            <li
                v-for="(item,index) in menuList"
                :key="index"
                class="menu_item"
            >
                <p class="desc_title">{{ item.title }}</p>
                <p
                    v-for="(itm,idx) in item.list"
                    :key="idx"
                    class="pointer"
                    :class="{'actived': currentUrl === itm.key}"
                    @click="toPage(itm.key)"
                >{{ itm.title }}</p>
            </li>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'RightMenu',
    directives: {},
    props: {
        currentUrl: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            menuList: [
                { title: this.$t('my.myActivity'), list: [{ title: this.$t('my.activity'), key: 'Activities' }] },
                { title: this.$t('my.myMessage'), list: [{ title: this.$t('my.message'), key: 'Message' }] },
                { title: this.$t('my.personalCenter'), list: [{ title: this.$t('my.personalInfo'), key: 'Profile' }, { title: this.$t('login.editPwd'), key: 'EditPassword' }] }
            ]
        }
    },
    created() {
    },
    methods: {
        toPage(url) {
            this.$emit('click', url)
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
@import '../../../styles/my';
.app-wrapper {
    .whtie_wrap {
        .right_menu {
            .menuList {
                .menu_item {
                    .actived {
                        color: #c72b1e;
                    }
                }
            }
        }
    }
}
</style>
